(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const activationHandler = svs.arena.pages.teams.activationHandler;
const hooks = svs.arena.shared.hooks;
const InlineErrorMessage = svs.components.tb_ui_react.inlineMessage.InlineErrorMessage;
const TeamsOverview = svs.arena.pages.teams.components.TeamsOverview;
const _svs$arena$store$team = svs.arena.store.teams.actions,
  fetchTeams = _svs$arena$store$team.fetchTeams,
  setTeamBalance = _svs$arena$store$team.setTeamBalance,
  fetchCustomerId = _svs$arena$store$team.fetchCustomerId;
const _svs$arena$constants = svs.arena.constants,
  routes = _svs$arena$constants.routes,
  depositType = _svs$arena$constants.depositType,
  returnStatus = _svs$arena$constants.returnStatus;
const _svs$arena$shared$dep = svs.arena.shared.deposit.doDeposit,
  submitDeposit = _svs$arena$shared$dep.submitDeposit,
  submitInviteDeposit = _svs$arena$shared$dep.submitInviteDeposit,
  submitCreateDeposit = _svs$arena$shared$dep.submitCreateDeposit;
const Teams = () => {
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const _hooks$useTeams = hooks.useTeams(60),
    teams = _hooks$useTeams.data,
    error = _hooks$useTeams.error;
  const teamDetails = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.teamDetails;
  });
  const _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    triggerActions = _React$useState2[0],
    setTriggerActions = _React$useState2[1];
  const handleFetchTeams = () => {
    dispatch(fetchTeams());
  };
  const depositLocalStorageHandler = async (data, err) => {
    if (data && !err && data.syndicateId) {
      var _depositData;
      let depositData;
      if (parseInt(data.amount, 10) > 0) {
        switch (data.depositType) {
          case depositType.INVITE:
            depositData = await submitInviteDeposit(data.amount, data.syndicateId);
            break;
          case depositType.CREATE:
            depositData = await submitCreateDeposit(data.amount, data.syndicateId);
            break;
          default:
            depositData = await submitDeposit(data.amount, data.syndicateId);
            break;
        }
      }
      if (((_depositData = depositData) === null || _depositData === void 0 ? void 0 : _depositData.status) === returnStatus.SUCCESS) {
        dispatch(setTeamBalance({
          teamId: data.syndicateId,
          memberBalance: depositData.memberBalance,
          syndicateBalance: depositData.syndicateBalance,
          playableAmount: depositData.playableAmount
        }));
      }
      if (depositData) {
        svs.components.Storage.browser.remove('syndicateDepositAmount', 'syndicate');
      }
    }
  };
  React.useEffect(() => {
    var _svs$components;
    dispatch(fetchCustomerId());
    (_svs$components = svs.components) === null || _svs$components === void 0 || (_svs$components = _svs$components.Storage) === null || _svs$components === void 0 || _svs$components.browser.get('syndicateDepositAmount', 'syndicate', async (data, err) => {
      await depositLocalStorageHandler(data, err);
    });
  }, []);

  React.useEffect(() => {
    if (triggerActions && (teamDetails === null || teamDetails === void 0 ? void 0 : teamDetails.length) > 0) {
      setTriggerActions(false);
      if (teams !== null && teams !== void 0 && teams.some(specificTeam => (specificTeam === null || specificTeam === void 0 ? void 0 : specificTeam.isLeader) === true)) {
        activationHandler(dispatch);
      }
    }
  }, [teamDetails]);
  return React.createElement(React.Fragment, null, error && React.createElement(InlineErrorMessage, {
    actions: [{
      handleClick: handleFetchTeams,
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign"
  }, "N\xE5gonting gick fel n\xE4r dina lag skulle visas upp. F\xF6rs\xF6k igen om en stund."), (teams === null || teams === void 0 ? void 0 : teams.length) > 0 && !error && React.createElement(TeamsOverview, {
    teams: teams
  }), (teams === null || teams === void 0 ? void 0 : teams.length) <= 0 && !error && history.push(routes.TEAMS_CREATE));
};
svs.arena.pages.teams.Teams = Teams;

 })(window);